module.exports = __webpack_public_path__ + "static/media/15UN-Habitat9.64c42624.jpg";